import * as React from 'react';

import { cn, Select } from '@rematter/ui-web';

import { BookingPhotoRequirement } from '../../../_graphql/queryBookingPhotoRequirements';
import { useTranslations } from '../../../i18n/useTranslations';

type PhotoRequirementSelectProps = {
  value?: string;
  options: BookingPhotoRequirement[];
  onChange: (value?: string) => void;
  className?: string;
  disabled?: boolean;
};

export const PhotoRequirementSelect: React.FC<PhotoRequirementSelectProps> = ({
  value,
  options,
  onChange,
  className = '',
  disabled = false,
}) => {
  const t = useTranslations();

  const handleChange = (selectedValue: string) => {
    // Special value means "none" was selected
    onChange(selectedValue === '__none__' ? undefined : selectedValue);
  };

  const selectOptions = React.useMemo(
    () =>
      options.map((option) => ({
        key: option.id,
        label: option.description,
        isDisabled: option.disabled,
      })),
    [options],
  );

  return (
    <Select
      value={value}
      onChange={handleChange}
      options={selectOptions}
      withEmptyOption
      emptyOptionLabel={t.loadDetail.photos.none}
      placeholder={t.shared.selectRequirement}
      className={cn('@PhotoRequirementSelect', className)}
      isDisabled={disabled}
    />
  );
};
